import React, { useRef } from "react";
import { Link } from "react-router-dom";
import logoImg from "../../assets/imgs/logo.svg";
import Hero from "../../sections/Hero";

import "./header.scss";

const Header = () => {
    const btnNavIcon = useRef();
    const navMobile = useRef();

    const handleShowNavMenu = () => {
        navMobile.current.classList.toggle("active");
    };

    return (
        <div className="grid wide">
            <header ref={navMobile} className="nav">
                <Link to="/" className="nav__logoImg">
                    <img src={logoImg} alt="DOSE-logo" width="128" />
                </Link>

                <div className="nav__paper">
                    <a
                        className="nav__paper__text"
                        href="https://www.dosetoken.com/whitepaper.pdf"
                        target="_blank"
                        rel="noreferrer"
                    >
                        WhitePaper
                    </a>
                </div>
                <div className="btnNavMobile">
                    <i
                        ref={btnNavIcon}
                        onClick={() => handleShowNavMenu(true)}
                        className="ri-menu-line menu-mobile"
                    ></i>
                    <i
                        onClick={() => handleShowNavMenu(false)}
                        className="ri-close-line btn-close "
                    ></i>
                </div>
            </header>

            <Hero />
        </div>
    );
};

export default Header;
